import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";

import { doRequestSMS, doRequestLogin } from "../../../actions/session";
import { isSessionLoggedIn } from "../../../selectors/session";
import { getCurrentChannel } from "../../../lib/channelValidator";

import { FormElement, ButtonElement } from "./SmsVerificationFormContent.styles";
import Button from "../Button/Button";

import MsisdnForm from "./atoms/MsisdnForm/MsisdnForm";
import SmsCodeForm from "./atoms/SmsCodeForm/SmsCodeForm";
import { validNumericField } from "../../../lib/validators";

const SmsVerificationFormContent = ({ onRequestSMS, onRequestLogin, history, closeModal }) => {
  const [msisdn, setMsisdn] = useState("");
  const [smsCode, setSmsCode] = useState("");
  const [firstPage, setFirstPage] = useState(true);

  const channelByPath = getCurrentChannel(history.location);

  const isLogged = useSelector(state => isSessionLoggedIn(state));

  useEffect(() => {
    setFirstPage(msisdn === "");
  }, [firstPage]);

  const handleSubmit = e => {
    e.preventDefault();

    const unmaskedMsisdn = msisdn.replace(/\D/g, "");

    if (firstPage) {
      if (!validNumericField(11)(msisdn)) return false;

      onRequestSMS(unmaskedMsisdn);
      setFirstPage(!validNumericField(11)(msisdn));
    } else {
      if (!validNumericField(5)(smsCode)) return false;

      onRequestLogin(unmaskedMsisdn, smsCode, "sms", channelByPath, "landing", true);

      if (!isLogged) {
        closeModal();
      }
    }

    return true;
  };

  const resetMsisdn = e => {
    e.preventDefault();

    setMsisdn("");
    setSmsCode("");
    setFirstPage(true);
  };

  return (
    <FormElement>
      {firstPage ? (
        <MsisdnForm msisdn={msisdn} setMsisdn={setMsisdn} />
      ) : (
        <SmsCodeForm msisdn={msisdn} smsCode={smsCode} setSmsCode={setSmsCode} />
      )}
      <Button
        text="Continuar"
        disabled={firstPage ? !validNumericField(11)(msisdn) : !validNumericField(5)(smsCode)}
        onClick={handleSubmit}
        width={234}
      />
      {!firstPage && (
        <ButtonElement onClick={resetMsisdn} type="button">
          Reenviar código {">"}
        </ButtonElement>
      )}
    </FormElement>
  );
};

SmsVerificationFormContent.propTypes = {
  onRequestSMS: PropTypes.func.isRequired,
  onRequestLogin: PropTypes.func.isRequired,
  closeModal: PropTypes.func,
  history: PropTypes.object.isRequired,
};

SmsVerificationFormContent.defaultProps = {
  closeModal: () => {},
};

const mapDispatchToProps = {
  onRequestSMS: doRequestSMS,
  onRequestLogin: doRequestLogin,
};

export default connect(
  null,
  mapDispatchToProps
)(SmsVerificationFormContent);
